// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"58c35e15","434":"b70165c5"}[chunkId] + ".chunk.js";
};